import React from "react";

// Past briefs (append-only snapshots). Selecting one loads that stored snapshot; it's never regenerated.
export default function BriefHistory({ rows, currentId, onOpen }) {
  if (!rows.length) return <p className="text-sm" data-testid="brief-history-empty">No earlier briefs yet.</p>;
  return (
    <ul className="space-y-1" data-testid="brief-history">
      {rows.map((r) => (
        <li key={r.id}>
          <button type="button" onClick={() => onOpen(r.id)} aria-current={r.id === currentId ? "true" : undefined}
            className={`w-full text-left min-h-[44px] px-3 rounded border text-sm focus:outline-none focus:ring-2 focus:ring-erf-gold ${r.id === currentId ? "border-erf-gold bg-erf-cream" : "border-erf-borderCream bg-white hover:bg-erf-cream"}`}
            data-testid={`brief-history-${r.id}`}>
            {r.brief_date} · {r.trigger === "scheduled" ? "Morning run" : "Regenerated"} · {new Date(r.generated_at).toLocaleTimeString([], { timeStyle: "short" })}
            {r.stale ? " · stale" : ""}
          </button>
        </li>
      ))}
    </ul>
  );
}
